var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _circle2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 846.13514,
    height: 772.40917,
    viewBox: "0 0 846.13514 772.40917",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ef8ddbf2-422b-4660-b5cd-bfa08ac6b7d7-204",
    "data-name": "Path 2389",
    d: "M988.75746,326.21557l-3.791-1.274,34.8-103.872a63.4,63.4,0,0,0-39.97614-80.256l-.00286-.001h0l-220.072-73.716a63.4,63.4,0,0,0-80.256,39.97609l-.001.00291h0l-190.892,569.85a63.4,63.4,0,0,0,39.9761,80.25605l.0029.001h0l220.067,73.72a63.4,63.4,0,0,0,80.254-39.978h0l131.329-392.04,3.792,1.27Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fd0ceacc-b1f5-4281-8e70-8593bae263ea-205",
    "data-name": "Path 2390",
    d: "M976.96644,157.26956l-28.726-9.623a22.495,22.495,0,0,1-29.592,22.77l-126.072-42.233a22.495,22.495,0,0,1-9.9-36l-26.83-8.988a47.348,47.348,0,0,0-59.935,29.856l-190.619,569.013a47.348,47.348,0,0,0,29.856,59.935h0l221.127,74.075a47.348,47.348,0,0,0,59.935-29.856h0l190.614-569.014a47.348,47.348,0,0,0-29.8576-59.93488Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ff2c3c85-1cba-4c81-ad38-62c498a2a918-206",
    "data-name": "Path 2391",
    d: "M921.66645,348.16757l-235.984-79.052a4.614,4.614,0,0,1-2.906-5.834l19.61-58.54a4.614,4.614,0,0,1,5.834-2.906l235.986,79.053a4.614,4.614,0,0,1,2.906,5.834l-19.61,58.538a4.614,4.614,0,0,1-5.834,2.906Zm-214.032-144.582a2.768,2.768,0,0,0-3.5,1.744l-19.61,58.538a2.768,2.768,0,0,0,1.744,3.5l235.985,79.053a2.768,2.768,0,0,0,3.5-1.744l19.613-58.535a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a7bacb06-5dda-4315-86f5-9fde62022a18-207",
    "data-name": "Path 2392",
    d: "M844.07942,579.78259l-235.985-79.052a4.614,4.614,0,0,1-2.906-5.834l36.298-108.355a4.614,4.614,0,0,1,5.834-2.906l235.986,79.05a4.614,4.614,0,0,1,2.906,5.834l-36.3,108.357A4.614,4.614,0,0,1,844.07942,579.78259Zm-197.345-194.4a2.768,2.768,0,0,0-3.5,1.744l-36.298,108.355a2.768,2.768,0,0,0,1.744,3.5l235.986,79.053a2.768,2.768,0,0,0,3.5-1.744l36.3-108.357a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a78be333-998c-4fe1-92ac-6c17265b914a-208",
    "data-name": "Path 2393",
    d: "M889.46644,438.48056l-104.879-35.139a4.614,4.614,0,0,1-2.906-5.834l19.61-58.538a4.614,4.614,0,0,1,5.834-2.906l104.88208,35.138a4.614,4.614,0,0,1,2.906,5.834l-19.609,58.538A4.614,4.614,0,0,1,889.46644,438.48056Zm-82.927-100.665a2.768,2.768,0,0,0-3.5,1.744l-19.609,58.538a2.768,2.768,0,0,0,1.744,3.5l104.882,35.134a2.768,2.768,0,0,0,3.5-1.744l19.61-58.538a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b3f2a87a-cc28-4d1a-8acd-979c53a8dd39-209",
    "data-name": "Path 2394",
    d: "M665.54542,677.45556l-104.879-35.134a4.614,4.614,0,0,1-2.906-5.834l36.591-109.231a4.614,4.614,0,0,1,5.834-2.906l104.881,35.134a4.614,4.614,0,0,1,2.906,5.834l-36.593,109.231A4.614,4.614,0,0,1,665.54542,677.45556Zm-65.949-151.358a2.768,2.768,0,0,0-3.5,1.744l-36.592,109.231a2.768,2.768,0,0,0,1.744,3.5l104.883,35.135a2.768,2.768,0,0,0,3.5-1.744l36.591-109.231a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "bb07296c-c3fc-491e-8a85-4137ac9f94aa-210",
    "data-name": "Path 2395",
    d: "M794.9004,720.78857l-104.883-35.135a4.614,4.614,0,0,1-2.906-5.834l36.591-109.231a4.614,4.614,0,0,1,5.834-2.906l104.883,35.135a4.614,4.614,0,0,1,2.906,5.834l-36.59094,109.23A4.614,4.614,0,0,1,794.9004,720.78857Zm-65.949-151.358a2.768,2.768,0,0,0-3.5,1.744l-36.592,109.231a2.768,2.768,0,0,0,1.744,3.5l104.88293,35.136a2.768,2.768,0,0,0,3.5-1.744l36.591-109.231a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a320c467-7a2a-401b-bd10-29e63d92c9f6",
    "data-name": "Ellipse 477",
    cx: 492.449,
    cy: 369.92014,
    r: 18.774,
    fill: "#447113"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "b9e531ec-0ab3-46c5-ae54-579cfd03e1f5-211",
    "data-name": "Path 2396",
    d: "M714.46644,435.62057a3.12907,3.12907,0,1,0-1.988,5.934l139.869,46.854a3.12907,3.12907,0,1,0,1.988-5.934h0Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ad39a0b5-50a7-48f2-b8cb-2db0547457f7-212",
    "data-name": "Path 2397",
    d: "M708.50642,453.42157a3.12907,3.12907,0,1,0-1.988,5.934l60.186,20.162a3.12907,3.12907,0,1,0,1.988-5.934h0Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "aac09e93-991f-40c6-86d0-b318c2c011d1-213",
    "data-name": "Path 2398",
    d: "M644.20546,463.53457c-2.257-.756-4.539-.04-5.087,1.6s.843,3.582,3.1,4.338l192.976,64.645c2.257.756,4.539.04,5.087-1.6s-.843-3.582-3.1-4.338Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "f158e8ac-632b-46f0-9cf0-44644e76b9a4-214",
    "data-name": "Path 2399",
    d: "M638.24244,481.33657c-2.257-.756-4.539-.04-5.087,1.6s.843,3.582,3.1,4.338l192.976,64.645c2.257.756,4.539.04,5.087-1.6s-.843-3.582-3.1-4.338Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "b837b54e-04c2-4911-922a-03186401a785",
    "data-name": "Ellipse 478",
    cx: 557.43997,
    cy: 181.71815,
    r: 18.774,
    fill: "#447113"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "b88d563f-8e66-4064-9d4c-186cef5c87ad-215",
    "data-name": "Path 2400",
    d: "M779.45942,247.41757a3.12907,3.12907,0,1,0-1.988,5.934h0l139.869,46.854a3.12907,3.12907,0,1,0,1.988-5.934h0Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "b990f7ae-58a3-4b3d-8dda-750e08426c01-216",
    "data-name": "Path 2401",
    d: "M773.49641,265.21957a3.12907,3.12907,0,1,0-1.988,5.934l60.186,20.162a3.12907,3.12907,0,1,0,1.988-5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "a3d5ec06-af2b-4b16-90b4-10a3978e7f3c-217",
    "data-name": "Path 2402",
    d: "M760.01942,395.12756l-98.389-32.959,36.589-32.349a4.986,4.986,0,0,1,8.19,2.743l4.152,20.446,26.577-23.5a6.243,6.243,0,0,1,10.253,3.435Zm-94.776-33.693,92.334,30.931-11.993-59.051a4.4,4.4,0,0,0-7.225-2.42l-28.969,25.611-4.788-23.575a3.142,3.142,0,0,0-5.161-1.729Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "ad2d9a36-cccf-4762-a8b2-ae4cbcf1fc8d-218",
    "data-name": "Path 2404",
    d: "M760.11543,395.14755l-104.882-35.134a4.614,4.614,0,0,1-2.906-5.834l19.609-58.538a4.614,4.614,0,0,1,5.834-2.906l104.883,35.135a4.614,4.614,0,0,1,2.906,5.834l-19.61,58.537a4.614,4.614,0,0,1-5.834,2.906Zm-82.93-100.665a2.768,2.768,0,0,0-3.5,1.744l-19.609,58.538a2.768,2.768,0,0,0,1.744,3.5l104.883,35.135a2.768,2.768,0,0,0,3.5-1.744l19.61-58.538a2.768,2.768,0,0,0-1.744-3.5Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "ff89cf89-8b1b-4dc3-86a1-ad04f586c716-219",
    "data-name": "Path 2405",
    d: "M614.98445,554.36157a3.12908,3.12908,0,1,0-1.988,5.934l60.186,20.162a3.12908,3.12908,0,0,0,1.988-5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "bdb6c5c0-7147-4e18-95bd-6c2e13251f4c-220",
    "data-name": "Path 2406",
    d: "M609.12843,571.84155a3.12908,3.12908,0,1,0-1.988,5.934h0l60.187,20.166a3.12909,3.12909,0,0,0,1.988-5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "e711c4eb-2570-4817-927e-bed9d0e120e8-221",
    "data-name": "Path 2408",
    d: "M780.09742,690.77655a3.12908,3.12908,0,0,0,1.988-5.934l-60.186-20.162a3.12908,3.12908,0,0,0-1.988,5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "ac126517-37f4-4549-a663-190a6b7a92b8-222",
    "data-name": "Path 2409",
    d: "M785.95344,673.29559a3.12908,3.12908,0,1,0,1.988-5.934l-60.186-20.162a3.12908,3.12908,0,1,0-1.988,5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "b0744aa1-6c52-44f5-8f87-5c835d602c4a-223",
    "data-name": "Path 2409",
    d: "M879.95344,393.29559a3.12908,3.12908,0,1,0,1.988-5.934l-60.186-20.162a3.12908,3.12908,0,1,0-1.988,5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "f9fb24f1-195d-4908-aecd-a74b480672b4-224",
    "data-name": "Path 2409",
    d: "M874.95344,407.29559a3.12908,3.12908,0,1,0,1.988-5.934l-60.186-20.162a3.12908,3.12908,0,1,0-1.988,5.934Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb1fd747-6b67-4cb9-858c-4d0f6fa12359",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a5dd78ed-2df1-42f3-9bac-4ba46f4211fe",
    "data-name": "Ellipse 476",
    cx: 193.98999,
    cy: 277.19815,
    r: 31.83,
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f00778a4-99fe-4ded-96db-b98a687eaf54-225",
    "data-name": "Path 2387",
    d: "M352.52343,344.93155c2.523-.151,4.987.7,7.493,1.035,8.965,1.19,18.29-5.315,20.27-14.139a10.84845,10.84845,0,0,1,1.037-3.378c1.38-2.253,4.522-2.682,7.112-2.164s5.046,1.73,7.684,1.869c4.073.214,7.983-2.294,10.154-5.747a19.48818,19.48818,0,0,0,2.492-11.77l-1.953,2.049a9.91821,9.91821,0,0,1-.884-5.39,6.255,6.255,0,0,0-5.925,1.516c-1.722.183-.422-3.193-1.7-4.36a2.959,2.959,0,0,0-2.082-.389c-3.663.035-6.626-2.766-9.512-5.021a40.42031,40.42031,0,0,0-17.071-7.787c-4.136-.807-8.534-.936-12.456.6a26.60866,26.60866,0,0,0-8.412,5.967c-6.141,5.9-11.579,12.843-14.133,20.97a35.30019,35.30019,0,0,0-.169,20.47c1.029,3.474,4.132,15.373,8.674,15.65C348.84542,355.26355,345.42043,345.35556,352.52343,344.93155Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edf96d50-4ce8-4ce1-a197-c1cb2bbecc75-226",
    "data-name": "Path 111",
    d: "M308.44643,595.83955a14.64,14.64,0,0,0,2.154-22.345l5.679-126.767-28.913,3.245,1.68,124a14.72,14.72,0,0,0,19.4,21.871Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7c32b38-e526-409e-9958-50b8ffad01a0-227",
    "data-name": "Path 112",
    d: "M361.19143,810.42757l16.456,2.893,16.264-62.1-21.561-4.27Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b6720e1c-54ee-4da4-8e92-2cd2033f0b28-228",
    "data-name": "Path 113",
    d: "M406.58244,834.20455l-51.72334-9.13692,3.53011-19.98368,31.73966,5.6068a20.29309,20.29309,0,0,1,16.45357,23.5138Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aff6290b-fbd1-41c3-8a68-a3ddd60c11e3-229",
    "data-name": "Path 114",
    d: "M316.02444,818.66556h16.707l7.948-64.445h-24.658Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f02f1576-8f9c-43fb-a0f1-30b59e5759a8-230",
    "data-name": "Path 115",
    d: "M364.93943,834.17958h-52.511v-20.288h32.223a20.288,20.288,0,0,1,20.288,20.288Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b96fab23-cef4-43fc-8373-5902972d74dd-231",
    "data-name": "Path 116",
    d: "M385.73442,795.56653a6.45519,6.45519,0,0,1-.78-.046l-19.666-1.618a6.651,6.651,0,0,1-5.8294-7.38171q.0195-.16617.04739-.3313l19.528-96.32593-12.27-64.7a2.217,2.217,0,0,0-4.387.218l-18.069,164.396a6.71,6.71,0,0,1-7.1,6.047l-18.527-.69a6.661,6.661,0,0,1-6.182-6.311l1.48-198.656,96.055-12.006,6.71,103.63-.027.11-24.52,108.583A6.658,6.658,0,0,1,385.73442,795.56653Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b76097f2-52bd-497e-a273-af776f029639-232",
    "data-name": "Path 117",
    d: "M377.18642,605.28556a27.40694,27.40694,0,0,1-14.8-4.233c-16.214-10.134-34.63-6.106-44.165-2.8a6.65106,6.65106,0,0,1-5.752-.655,6.55605,6.55605,0,0,1-3.031-4.84l-17.335-154.856c-2.906-25.945,12.723-50.338,37.161-58h0q1.377-.432,2.8-.819a53.92592,53.92592,0,0,1,44.935,7.8,54.791,54.791,0,0,1,23.4,40l14.6,155.89a6.55193,6.55193,0,0,1-2.087,5.461C407.79543,592.96757,392.94445,605.28355,377.18642,605.28556Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#447113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7c0fd9c-4296-4103-8950-cd245101458a-233",
    "data-name": "Path 118",
    d: "M324.38942,471.10755l-39.118-4.3a7.792,7.792,0,0,1-6.685-9.722l9.957-37.95a21.64,21.64,0,1,1,43.03363,4.61126q-.01308.12246-.02761.24472l1.478,39.079a7.792,7.792,0,0,1-8.638,8.037Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#447113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e4415faf-95a5-4fec-be4a-0e91d9da7267-234",
    "data-name": "Path 119",
    d: "M414.83642,590.41155a14.63993,14.63993,0,0,0-.553-22.443l-9.639-126.527-28.331,6.378,16.631,123.21805a14.72,14.72,0,0,0,21.893,19.374Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bebc4112-7456-4b85-95f3-28c2273ba549-235",
    "data-name": "Path 120",
    d: "M365.45042,463.15358a7.783,7.783,0,0,1-2.478-6l1.478-39.079a21.64,21.64,0,0,1,43.006-4.856l9.957,37.95a7.79211,7.79211,0,0,1-6.685,9.722l-39.118,4.3a7.783,7.783,0,0,1-6.16-2.041Z",
    transform: "translate(-176.93243 -63.79541)",
    fill: "#447113"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "a6aa4d97-c7f3-4c66-8fef-1a835a984f6d",
    "data-name": "Rectangle 256",
    y: 770.40917,
    width: 738.21997,
    height: 2,
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.b29f74425a4dfb9aaee95bd9533306ec.svg";
export { ForwardRef as ReactComponent };